import { render, staticRenderFns } from "./PhotoSelector.vue?vue&type=template&id=9170c0b4&scoped=true&"
import script from "./PhotoSelector.vue?vue&type=script&lang=js&"
export * from "./PhotoSelector.vue?vue&type=script&lang=js&"
import style0 from "./PhotoSelector.vue?vue&type=style&index=0&id=9170c0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9170c0b4",
  null
  
)

export default component.exports